export const getEntityType = (url: string): string => {
  if (url.includes('/record/0-1/')) return 'Contact'
  if (url.includes('/record/0-2/')) return 'Company'
  if (url.includes('/record/0-3/')) return 'Deal'
  if (url.includes('/record/0-5/')) return 'Ticket'
  if (url.includes('/deal/')) return 'Deal'
  if (url.includes('/contact/')) return 'Contact'
  if (url.includes('/company/')) return 'Company'
  return 'HubSpot'
}

export const getUserName = (
  userId: string | number | null | undefined,
  internalAdmins: any[]
): string => {
  if (!userId) return ''
  const user = internalAdmins?.find(
    (admin) => admin.id.toString() === userId.toString()
  )
  return user
    ? user.name || user.first_name || user.email || 'Unknown'
    : 'Unknown User'
}

export const formatAmount = (
  amount: number | string | null | undefined
): string => {
  if (amount === null || amount === undefined) return 'N/A'

  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  if (Number.isNaN(numAmount)) return 'N/A'

  return `$${(numAmount / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

export const getStripeUrl = (
  subscriptionId: string | null | undefined
): string | null => {
  if (!subscriptionId) return null
  return `https://dashboard.stripe.com/subscriptions/${subscriptionId}`
}

export const hasAccountManager = (org: any): boolean => {
  return org.account_manager_user_id && org.account_manager_user_id !== ''
}

export const hasSalesRep = (org: any): boolean => {
  return (
    org.organization_subscription?.sale_rep_id &&
    org.organization_subscription.sale_rep_id !== ''
  )
}

export const isOrganizationUpdated = (org: any): boolean => {
  return hasAccountManager(org) && hasSalesRep(org)
}

export const isOrganizationPending = (org: any): boolean => {
  return !hasAccountManager(org) || !hasSalesRep(org)
}
